import voicesData from "@/assets/voices/voices.json";

/**
 * Voice configuration for agent speech
 */
export interface Voice {
  id: string; // Gemini model voice name (not user-facing) e.g., "Aoede", "Orus"
  name: string; // External Display name e.g., "Some name"
  description: string; // e.g., "Feminine, middle pitch"
  isDefault?: boolean; // Mark default voice
}

/**
 * Get the sample file path for a voice
 * Uses require() for proper bundling on web platforms
 */
export const getVoiceSamplePath = (voiceId: string): string => {
  // Map voice IDs to their actual required assets
  const voiceAssetMap: Record<string, any> = {
    Aoede: require("@/assets/voices/samples/Aoede.wav"),
    Orus: require("@/assets/voices/samples/Orus.wav"),
    Gacrux: require("@/assets/voices/samples/Gacrux.wav"),
    Algieba: require("@/assets/voices/samples/Algieba.wav")
  };

  const asset = voiceAssetMap[voiceId];
  if (!asset) {
    throw new Error(`Voice sample not found for voice ID: ${voiceId}`);
  }

  // For web, require() returns an object with 'default' property containing the URL
  // For native, require() returns the asset directly
  return typeof asset === "object" && asset.default ? asset.default : asset;
};

/**
 * Get all available voice options
 */
export const getAvailableVoices = (): Voice[] => {
  return voicesData.voices;
};

/**
 * Get the default voice
 */
export const getDefaultVoice = (): Voice => {
  const defaultVoice = voicesData.voices.find((voice) => voice.isDefault);
  if (!defaultVoice) {
    throw new Error("No default voice found in configuration");
  }
  return defaultVoice;
};

/**
 * Get voice by ID
 */
export const getVoiceById = (voiceId: string): Voice | null => {
  return voicesData.voices.find((voice) => voice.id === voiceId) || null;
};
